





































































































































import { Vue, Component, Prop } from 'vue-property-decorator'

@Component({
  components: {
    'text-input': () => import('@/components/reports/components/TextInput.vue'),
    'checked-input': () => import('@/components/reports/components/CheckedInput.vue')
  }
})
export default class Page1 extends Vue {
  blockOne = [
    { label: 'ОБЛАГАЕМЫЕ ПОСТАВКИ НА ТЕРРИТОРИИ КР', number: '050', id: 'x050' },
    { label: 'ПОСТАВКИ, ОБЛАГАЕМЫЕ ПО НУЛЕВОЙ СТАВКЕ', number: '051', id: 'x051' },
    { label: 'В ТОМ ЧИСЛЕ В ГОСУДАРТСВА-ЧЛЕНЫ ЕВРАЗИЙСКОГО ЭКОНОМИЧЕСКОГО СОЮЗА', number: '052', id: 'x052' },
    { label: 'ОСВОБОЖДЕННЫЕ И НЕОБЛАГАЕМЫЕ ПОСТАВКИ', number: '053', id: 'x053' },
    { label: 'ОБЩАЯ СТОИМОСТЬ ПОСТАВОК (=050+051+053)', number: '054', id: 'x054', disabled: true },
    { label: 'ПРИОБРЕТЕННЫЕ МАТЕРИАЛЬНЫЕ РЕСУРСЫ В КР', number: '055', id: 'x055' },
    { label: 'ИМПОРТ МАТЕРИАЛЬНЫХ РЕСУРСОВ В КР', number: '056', id: 'x056' },
    { label: 'В ТОМ ЧИСЛЕ ИЗ ГОСУДАРТСВ-ЧЛЕНОВ ЕВРАЗИЙСКОГО ЭКОНОМИЧЕСКОГО СОЮЗА', number: '057', id: 'x057' },
    {
      label: 'ОБЩАЯ СТОИМОСТЬ ПРИОБРЕТЕННЫХ МАТЕРИАЛЬНЫХ РЕСУРСОВ (=055+056)',
      number: '058',
      id: 'x058',
      disabled: true
    }
  ]
  blockTwo = [
    {
      label: 'ОБЩАЯ СУММА НДС ЗА ПРОИЗВЕДЕННЫЕ ПОСТАВКИ ( =050 х ставку / 100%)',
      number: '059',
      id: 'x059',
      disabled: true
    },
    { label: 'НДС ЗА ПРИОБРЕТЕННЫЕ МАТЕРИАЛЬНЫЕ РЕСУРСЫ, ПОДЛЕЖАЩИЙ ЗАЧЕТУ', number: '060', id: 'x060' },
    { label: 'НДС НА ИМПОРТ, ПОДЛЕЖАЩИЙ ЗАЧЕТУ', number: '061', id: 'x061' },
    { label: 'В ТОМ ЧИСЛЕ ИЗ ГОСУДАРТСВ-ЧЛЕНОВ ЕВРАЗИЙСКОГО ЭКОНОМИЧЕСКОГО СОЮЗА', number: '062', id: 'x062' },
    { label: 'НДС ЗА ПРИОБРЕТЕННЫЕ МАТЕРИАЛЬНЫЕ РЕСУРСЫ, НЕ ПОДЛЕЖАЩИЙ ЗАЧЕТУ', number: '063', id: 'x063' },
    {
      label: 'ОБЩАЯ СУММА НДС ЗА ПРИОБРЕТЕННЫЕ МАТЕРИАЛЬНЫЕ РЕСУРСЫ, ПОДЛЕЖАЩАЯ ЗАЧЕТУ (=060+061)',
      number: '064',
      id: 'x064',
      disabled: true
    },
    {
      label: 'В ТОМ ЧИСЛЕ НДС ЗА ПРИОБРЕТЕННЫЕ МАТЕРИАЛЬНЫЕ РЕСУРСЫ, ИСПОЛЬЗУЕМЫЕ ДЛЯ ПОСТАВОК С НУЛЕВОЙ СТАВКОЙ',
      number: '065',
      id: 'x065'
    },
    {
      label: 'НАЛОГОВОЕ ОБЯЗАТЕЛЬСТВО (=059-064) (УКАЖИТЕЗНАК МИНУС, ЕСЛИ ЗНАЧЕНИЕ ОТРИЦАТЕЛЬНОЕ)',
      number: '066',
      id: 'x066'
    },
    {
      label:
        'НАЛОГОВОЕ ОБЯЗАТЕЛЬСТВО ПО ПРОМЫШЛЕННОЙ ПЕРЕРАБОТКЕ СЕЛЬСКОХОЗЯЙСТВЕННОЙ ПРОДУКЦИИ ОТЕЧЕСТВЕННОГО ПРОИЗВОДСТВА, ПОДЛЕЖАЩЕЕ УМЕНЬШЕНИЮ НА 80% (УКАЖИТЕЦИФРУ «0», ЕСЛИ ЗНАЧЕНИЕ ОТРИЦАТЕЛЬНОЕ)',
      number: '067',
      id: 'x067'
    },
    {
      label: 'НАЛОГОВОЕ ОБЯЗАТЕЛЬСТВО ВСЕГО (=066-067) (УКАЖИТЕЗНАК МИНУС, ЕСЛИ ЗНАЧЕНИЕ ОТРИЦАТЕЛЬНОЕ)',
      number: '068',
      id: 'x068',
      disabled: true
    }
  ]
  blockThree = [
    { label: 'ОБЛАГАЕМЫЕ ПОСТАВКИ', number: '069', id: 'x069' },
    { label: 'СУММА НДС ЗА ПРОИЗВЕДЕННЫЕ ПОСТАВКИ', number: '070', id: 'x070' },
    { label: 'ПРИОБРЕТЕННЫЕ МАТЕРИАЛЬНЫЕ РЕСУРСЫ', number: '071', id: 'x071' },
    { label: 'СУММА НДС ЗА ПРИОБРЕТЕННЫЕ МАТЕРИАЛЬНЫЕ РЕСУРСЫ', number: '072', id: 'x072' }
  ]

  @Prop({ type: Object, default: () => ({}) }) data
  @Prop({ type: Array, default: () => [] }) apps

  public validateInput(event) {
    const input = event.target.value
    const index = event.target.selectionStart
    const val = input.slice(0, index) + event.key + input.slice(index)
    if (!/^([0-9]{1,11})$/.test(val)) return event.preventDefault()
  }
}
